module.exports = __webpack_public_path__ + "static/atlaskit-table-basic-117d81125e18d5bb30e4625a9ca8d9d2.png";